/**
 * Server Manifest Constants
 * 
 * IMPORTANT: These values must match the server-side constants in:
 * game-server/modules/ponder-flight-game/manifest/world/gravity.go
 * 
 * If server values change, update this file to match.
 */

// Earth radius in kilometers (for Haversine distance calculation)
// From: gravity.go distHaversine function
export const EarthRadiusKm = 6371;

/**
 * Calculate distance between two coordinates using Haversine formula
 * Mirrors server's distHaversine function in gravity.go
 */
export function calculateDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const lat1Rad = lat1 * (Math.PI / 180);
  const lat2Rad = lat2 * (Math.PI / 180);
  const deltaLat = (lat2 - lat1) * (Math.PI / 180);
  const deltaLon = (lon2 - lon1) * (Math.PI / 180);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1Rad) *
      Math.cos(lat2Rad) *
      Math.sin(deltaLon / 2) *
      Math.sin(deltaLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return EarthRadiusKm * c;
}
